import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import ComplianceInvestigationHeader from "./ComplianceInvestigationHeader";
import ComplianceInvestigationDetails from "./ComplianceInvestigationDetails";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import {
  loadComplianceInvestigationAsync,
  selectComplianceInvestigation,
} from "../../../redux/slices/complianceInvestigation";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page500 from "../../../pages/auth/Page500";

const ComplianceInvestigation = () => {
  const [loading, setLoading] = useState(false);
  const [
    loadingComplianceInvestigationId,
    setloadingComplianceInvestigationId,
  ] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const complianceInvestigationSelector = useAppSelector(
    selectComplianceInvestigation
  );

  const dispatch = useAppDispatch();

  let { profileNo, complianceInvestigationId } = useParams();
  if (!profileNo || !complianceInvestigationId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingComplianceInvestigationId !== complianceInvestigationId) {
    setloadingComplianceInvestigationId(complianceInvestigationId);
    dispatch(loadComplianceInvestigationAsync(complianceInvestigationId));
    return <Loading />;
  }

  const complianceInvestigation =
    complianceInvestigationSelector.complianceInvestigation;

  if (!complianceInvestigation) {
    return <Loading />;
  }

  if (!complianceInvestigation.response.ok) {
    if (complianceInvestigation.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ComplianceInvestigationHeader
            complianceInvestigation={complianceInvestigation}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ComplianceInvestigationDetails
            complianceInvestigation={complianceInvestigation}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            complianceInvestigation={complianceInvestigation}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        complianceInvestigation={complianceInvestigation}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default ComplianceInvestigation;
